module.exports = __webpack_public_path__ + "img/slika5.9cc0d0af.jpg";